import Swiper, { Navigation } from 'swiper';

Swiper.use([Navigation]);

const swiper = new Swiper('.settlements__swiper', {
  grabCursor: true,
  slidesPerView: 'auto',
  navigation: {
    nextEl: ".settlements__list__next",
    prevEl: ".settlements__list__prev",
  },
  breakpoints: {
    567: {
      slidesPerView: 1,
      spaceBetween: 56,
    },
		768: {
			slidesPerView: 2,
      spaceBetween: 56,
		},
    991: {
			slidesPerView: 3,
      spaceBetween: 56,
		}
  },
});


